import { useState } from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toDate = (s) => (s ? new Date(`${String(s).slice(0, 10)}T00:00:00`) : undefined);
const toYmd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const DatePicker = ({ value, onChange, placeholder = "Pick a date", className = "", testId, clearable = true }) => {
  const [open, setOpen] = useState(false);
  const d = toDate(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" data-testid={testId}
          className={`justify-start text-left font-normal rounded-sm w-full ${d ? "" : "text-slate-400"} ${className}`}>
          <CalendarIcon size={13} className="mr-1.5 shrink-0 text-slate-400" />
          <span className="truncate">{d ? format(d, "d MMM yyyy") : placeholder}</span>
          {clearable && d && (
            <X size={12} className="ml-auto shrink-0 text-slate-400 hover:text-rose-500"
              onClick={(e) => { e.stopPropagation(); onChange(""); }}
              data-testid={testId ? `${testId}-clear` : undefined} />
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 rounded-sm" align="start">
        <Calendar mode="single" selected={d} onSelect={(nd) => { onChange(nd ? toYmd(nd) : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
};
